import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useOutletContext } from 'react-router-dom';
import { withLang, langType } from '../../../i18n';
import surveyStyles from '../survey.module.css';
import { surveyType } from '../../../constants/types';
import TranslatedHTMLText from '../../TranslatedHTMLText';
import SurveyProgressBar from '../SurveyProgressBar';
import { routes } from '../../../constants';
import { autoFocusElementById, getSurveySchemaPartAmount } from '../../../util';

const RESPONSE_SUCCESS_TITLE_ID = 'response_success_title';

const ResponseSuccess = ({ translate, survey }) => {
  const t = translate;
  const schemaPartAmount = getSurveySchemaPartAmount(survey);
  let pageNumber;
  if (survey.researchConsentNeeded) {
    pageNumber = schemaPartAmount + 2;
  } else {
    pageNumber = schemaPartAmount + 1;
  }
  const [setCurrentPage, setPageCount] = useOutletContext();

  useEffect(() => {
    autoFocusElementById(RESPONSE_SUCCESS_TITLE_ID, 0);
  }, []);

  const renderTitle = () => (
    <div className="flex-inline">
      <h2 id={RESPONSE_SUCCESS_TITLE_ID} className="panel__title">{t('survey.responseSent')}</h2>
    </div>
  );

  return (
    <section className="fastFadeIn">
      <SurveyProgressBar
        current={pageNumber}
        total={schemaPartAmount}
        researchConsentNeeded={survey.researchConsentNeeded}
        setCurrentPage={setCurrentPage}
        setPageCount={setPageCount}
      />
      {renderTitle()}
      {/* WARNING: UH-670 - This might not be accessible if the html is not formatted correctly */}
      {survey.conclusion
        ? <TranslatedHTMLText html={survey.conclusion} /> : t('survey.responseSuccess')}
      <nav className={`${surveyStyles.navigation} ${surveyStyles.navigationLastPage}`}>
        <Link
          className={`${surveyStyles.button} button--outline`}
          to={routes.index}
        >
          {t('common.toFrontPage')}
        </Link>
      </nav>
    </section>
  );
};

ResponseSuccess.propTypes = {
  survey: surveyType.isRequired,
  ...langType
};

const mapStateToProps = ({ survey }) => ({
  survey: survey.surveyContent
});
export default withLang(connect(mapStateToProps)(ResponseSuccess));
